import { ThemeProp } from 'packages/web/src/theme/Themes';
import styled from 'styled-components';

import { Input } from '../..';
import Text from '../../Text';

export const Container = styled.div`
  max-width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  background: transparent;
  gap: 1.5rem;

  padding: 0 1rem 2.5rem 1rem;

  @media (min-width: ${(props: ThemeProp) => props.theme.breakpoints.minMobile}) {
    max-width: 22.125rem;
    gap: 1.25rem;
    padding: 1.125rem 1rem 0.75rem 1rem;
  }
`;

export const UnitsContainer = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const InputRangeContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 0.75rem;
`;

export const InputOptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  max-height: 3.875rem;
  overflow: hidden;
`;

export const InputOptionTitle = styled(Text)`
  font-weight: ${(props: ThemeProp) => props.theme.fontWeight.regular};
  font-size: ${(props: ThemeProp) => props.theme.fontVariants.desktop.body2.fontSize};
  line-height: ${(props: ThemeProp) => props.theme.fontVariants.desktop.body2.lineHeight};
  color: ${(props: ThemeProp) => props.theme.colors.neutrals.c800};
`;

export const InputContainer = styled.div`
  .nextui-input-main-container {
    margin-bottom: 0;
  }
`;

export const StyledInput = styled(Input).attrs((props) => {
  return {
    ...props,
    noMarginBottom: true,
    css: {
      '& .nextui-input-helper-text-container': {
        display: 'none !important',
      },
      '& .nextui-input-helper-text-container p': {
        display: 'none !important',
      },
      ...props.css,
    },
  };
})`
  height: 2.5rem !important;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  padding: 0 !important;

  .nextui-input-label--right {
    background: none;
    padding: 0.5rem 0.75rem 0.5rem 0;
    color: ${(props: ThemeProp) => props.theme.colors.black};
    font-weight: ${(props: ThemeProp) => props.theme.fontWeight.regular};
  }

  .nextui-input-label--left {
    background: none;
    padding: 0.5rem 0 0.5rem 0.75rem;
    color: ${(props: ThemeProp) => props.theme.colors.black};
    font-weight: ${(props: ThemeProp) => props.theme.fontWeight.regular};
  }
`;

export const SliderContainer = styled.div`
  display: flex;
  flex: 1;
`;

export const ButtonsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 1rem;

  button {
    font-weight: ${(props: ThemeProp) => props.theme.fontWeight.medium};
  }
`;
